import ProductDetails from "../Components/ProductDetails/ProductDetails";
import Home from "../Pages/Home/Home";
import Login from "../Pages/Login/Login";
import Registr from "../Pages/Registr/Registr.jsx";
import PaymentPage from "../Pages/PaymentPage/PaymentPage";
import Profile from "../Pages/Profile/Profile";
import Orders from "../Pages/Orders/Orders.jsx";
import CityDetails from "../Components/CityDetails/CityDetails.jsx";
import PaymentDetails from "../Components/PaymentDetails/PaymentDetails.jsx";
import OrderHistory from "../Components/OrderHistory/OrderHistory.jsx";
import Contacts from "../Pages/Contacts/Contacts.jsx";
import Salles from "../Pages/Salles/Salles.jsx";

export const HOME_PAGE = "/home";
export const CITIES_PAGE = "/cities";
export const LOGIN_PAGE = "/login";
export const REGISTRATION_PAGE = "/registration";
export const PROFILE_PAGE = "/profile";
export const PAYMENT_PATH = "/payment";
export const PRODUCT_PATH = "/products/:productId";
export const CITIESDETAILS_PATH = "/cities/:cityId";
export const PAYMENTID_PATH = "/payment/:idWallet";
export const ORDERS_PATH = "/orders/:orderId";
export const CONTACTS_PATH = "/contacts";
export const SALLES_PATH = "/salles";

export const ROUTESE = [
  { path: HOME_PAGE, element: <Home />, name: "Главная" },
  { path: REGISTRATION_PAGE, element: <Registr />, name: "Регистрация" },
  { path: LOGIN_PAGE, element: <Login />, name: "Вход" },
  { path: PROFILE_PAGE, element: <Profile />, name: "Профиль" },
  { path: CONTACTS_PATH,element: <Contacts/>,name: "Контакты" },
  { path: SALLES_PATH, element: <Salles />, name: "Акции" },
  { path: PRODUCT_PATH, element: <ProductDetails />, name: null },
  { path: CITIESDETAILS_PATH, element: <CityDetails />, name: null },
  { path: PAYMENTID_PATH, element: <PaymentDetails />, name: null },
  { path: PAYMENT_PATH, element: <PaymentPage />, name: null },
  { path: ORDERS_PATH, element: <Orders />, name: null },
  
  { path: "/profile/orders",element: <OrderHistory/>,name: null },
  
  
];


